import React, { useContext, useEffect } from 'react';
import {
  triggerMultiStepTeachingBubbleWithLock,
  MultiStepTeachingBubbleContext,
} from '@bingads-webui-campaign-react/multi-step-teaching-bubble';
import { CustomReportBuilderTeachingBubbleConfig, ReportHomePageTeachingBubbleConfig, ReportSaveAtUserLevelTeachingBubbleConfig } from './teaching-bubble-configs';

export const ReportHomePageBubbleRenderer = () => {
  const bubbleContext = useContext(MultiStepTeachingBubbleContext);

  useEffect(() => {
    triggerMultiStepTeachingBubbleWithLock({
      ...bubbleContext,
      featureName: ReportHomePageTeachingBubbleConfig.featureName,
    });
  }, [bubbleContext]);

  return <div />;
};

export const CustomReportBuilderBubbleRenderer = () => {
  const bubbleContext = useContext(MultiStepTeachingBubbleContext);

  useEffect(() => {
    triggerMultiStepTeachingBubbleWithLock({
      ...bubbleContext,
      featureName: CustomReportBuilderTeachingBubbleConfig.featureName,
    });
  }, [bubbleContext]);

  return <div />;
};

export const ReportSaveAtUserLevelTeachingBubbleRenderer = () => {
  const bubbleContext = useContext(MultiStepTeachingBubbleContext);

  useEffect(() => {
    triggerMultiStepTeachingBubbleWithLock({
      ...bubbleContext,
      featureName: ReportSaveAtUserLevelTeachingBubbleConfig.featureName,
    });
  }, [bubbleContext]);

  return <div />;
};
